import { render, staticRenderFns } from "./BannerLeft.vue?vue&type=template&id=f8db5b56&scoped=true&"
import script from "./BannerLeft.vue?vue&type=script&lang=js&"
export * from "./BannerLeft.vue?vue&type=script&lang=js&"
import style0 from "./BannerLeft.vue?vue&type=style&index=0&id=f8db5b56&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8db5b56",
  null
  
)

export default component.exports